(() => {
  const readyAttribute = 'data-tlc-paired-colors-ready';
  if (document.documentElement.hasAttribute(readyAttribute)) return;
  document.documentElement.setAttribute(readyAttribute, '');
  let pairedDestination = null;
  window.addEventListener('pageshow', () => { pairedDestination = null; });
  window.addEventListener('pageswap', (event) => {
    if (!pairedDestination) return;
    const destination = event.activation?.entry?.url;
    if (destination && destination !== pairedDestination) return;
    // Skip animation only for this explicit paired-product navigation.
    try { event.viewTransition?.skipTransition(); } catch { /* Navigation must continue. */ }
    pairedDestination = null;
  }, true);

  // Read the live control, not the previous server-rendered variant or URL.
  function syncLink(link) {
    const picker = link.closest('variant-picker[data-template-product-match="true"]');
    if (!picker || picker.dataset.productId !== link.dataset.tlcSourceProduct) return;
    const sizeControl = picker.querySelector('input[data-tlc-size-input]:checked, select[data-tlc-size-input]');
    if (!sizeControl || sizeControl.disabled || !sizeControl.value) return;

    let targets;
    try {
      targets = JSON.parse(link.dataset.tlcSizeTargets || '[]');
    } catch {
      return;
    }
    if (!Array.isArray(targets)) return;
    const selectedSize = sizeControl.value;
    const exact = targets.find((target) => target.size === selectedSize);
    const status = link.querySelector('[data-tlc-pair-status]');
    if (!exact) {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.dataset.tlcSizePreserved = 'false';
      link.classList.toggle('tlc-paired-color--unavailable', true);
      if (status) {
        status.textContent = link.dataset.tlcChooseSize || '';
        status.hidden = false;
      }
      return false;
    }
    // A sold-out exact match remains selected; never substitute an in-stock size.
    const target = exact;
    if (!target || typeof target.url !== 'string' || !/^\d+$/.test(target.id)) return;

    let destination;
    try {
      destination = new URL(target.url, window.location.href);
      const expected = new URL(link.dataset.tlcPairedUrl, window.location.href);
      if (destination.origin !== window.location.origin || destination.pathname !== expected.pathname) return;
      if (destination.searchParams.get('variant') !== target.id) return;
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
    } catch {
      return;
    }

    link.href = destination.pathname + destination.search + destination.hash;
    link.removeAttribute('aria-disabled');
    link.classList.toggle('tlc-paired-color--unavailable', false);
    link.dataset.tlcPairedVariant = target.id;
    link.dataset.tlcSizePreserved = exact ? 'true' : 'false';
    link.classList.toggle('tlc-paired-color--sold-out', target.available === false);
    if (status) {
      const message = !exact
        ? link.dataset.tlcChooseSize
        : target.available === false
          ? (link.dataset.tlcSoldOutPattern || '').replace('__TLC_SIZE__', selectedSize)
          : '';
      status.textContent = message || '';
      status.hidden = !message;
    }
    return true;
  }

  // Document delegation survives Shopify replacing the native picker section.
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-tlc-size-input]')) return;
    const picker = event.target.closest('variant-picker');
    picker?.querySelectorAll('a[data-tlc-size-targets]').forEach(syncLink);
  }, true);

  function prepareNavigation(event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-tlc-size-targets]');
    if (!link) return;
    const resolved = syncLink(link);
    if (resolved === false) {
      event.preventDefault();
      return;
    }
    if (resolved !== true || event.type !== 'click') return;
    if ((event.button !== undefined && event.button !== 0) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    // Own only unmodified paired navigation, including Enter-generated clicks.
    // Other links and modifier/new-tab actions retain native browser behavior.
    event.preventDefault();
    event.stopImmediatePropagation();
    pairedDestination = link.href;
    try { document.activeViewTransition?.skipTransition(); } catch { /* A finished animation must not block the link. */ }
    window.location.assign(pairedDestination);
  }
  // Keep normal browser navigation, modifiers, middle-click and keyboard activation.
  ['pointerdown', 'click', 'auxclick', 'contextmenu'].forEach((type) => {
    document.addEventListener(type, prepareNavigation, true);
  });
})();
